export const REQUEST_LOCATION_DETAILS = 'REQUEST_LOCATION_DETAILS'
export const LOCATION_DETAILS_RECEIVED = 'LOCATION_DETAILS_RECEIVED'

export const GET_RATES = 'GET_CAR_PARK_RATES'
export const SET_RATES = 'SET_CAR_PARK_RATES'

export const OCCUPANCY_STATUSES = {
    green: {
        colorCode: '#82be64',
        label: <T>car.park.availability.statuses.available</T>,
    },
    amber: {
        colorCode: '#f5a623',
        label: <T>car.park.availability.statuses.limited</T>,
    },
    red: {
        colorCode: '#e15046',
        label: <T>car.park.availability.statuses.full</T>,
    },
}
